import Item from '@/framework/base/classes/Item';
import AdminAttrib from '@/generated/classes/AdminAttrib';
import AdminInfo from '../classes/AdminInfo';
import HtmlAttrib from '../classes/HtmlAttrib';
import { ObjTypes } from '@/generated/classes/ObjTypes';
import { TitleCase } from '@/framework/base/helpers/String';
import Admin from '@/generated/classes/Admin';

export function getSelectValue(items: Item[], value: string, field: AdminAttrib): string {
  let res = ''
  const item = items.find(x => x.key == value);
  if (item) {
    res = item.title;
  }
  return res;
}

export function getHtmlAttrib(item: AdminAttrib, adminInfo: AdminInfo, objType: string, objName: string): HtmlAttrib {
  if (adminInfo.objType == ObjTypes.EMAIL) {
    const htmlAttrib = new HtmlAttrib();
    let objTypeName = TitleCase(ObjTypes[adminInfo.objType]);
    if (item.value == "preheaderHtmlId") {
      objTypeName = objTypeName + "-preHeader"
    }
    htmlAttrib.objType = objTypeName;
    htmlAttrib.objName = adminInfo.objName;
    htmlAttrib.publiContext = adminInfo.publiContext;
    Admin.loadPubliParam(adminInfo.publiContext).then((res) => {
      htmlAttrib.publiParams = res;
    })
    return htmlAttrib;
  }
  const htmlAttrib = new HtmlAttrib();
  htmlAttrib.objType = objType;
  htmlAttrib.objName = objName;

  return htmlAttrib;
}

export function getPubliContext(obj: any, objType: ObjTypes): string {
  let res = "";
  if (objType == ObjTypes.NOTIF_DEF) {
    res = obj.publiContext;
  }
  return res;
}

export function getObjName(field: AdminAttrib, obj: any, objType: ObjTypes): string {
  let res = "";
  if (objType == ObjTypes.NOTIF_DEF) {
    res = obj.code;
  }
  return res;
}

export function setObjName(obj: any, adminInfo: AdminInfo) {
  if ((adminInfo.objType == ObjTypes.EMAIL || adminInfo.objType == ObjTypes.SMS) && adminInfo.objName != "") {
    obj.name = adminInfo.objName;
  }
}

export function save(obj: any, htmlAttrib: HtmlAttrib, objType: ObjTypes): any {
  if (objType == ObjTypes.EMAIL) {
    if (htmlAttrib.objType.toLowerCase() == ObjTypes[ObjTypes.EMAIL].toLowerCase()) {
      obj.bodyHtmlId = htmlAttrib.id;
    } else if (htmlAttrib.objType.toLowerCase() == ObjTypes[ObjTypes.EMAIL].toLowerCase() + "-preheader") {
      obj.preheaderHtmlId = htmlAttrib.id;
    }
  } else if (objType == ObjTypes.SMS) {
    obj.messageHtmlId = htmlAttrib.id;
  } else {
    obj.helpHtmlId = htmlAttrib.id;
  }
  return obj;
}